import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { TransactionSyndicService } from '@service/syndic/transaction-syndic.service';
import { CompteService } from '@service/syndic/compte.service';
import { SyndicService } from '@service/syndic/syndic.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-transaction-syndic-add',
  templateUrl: './transaction-syndic-add.component.html',
  styleUrls: ['./transaction-syndic-add.component.scss']
})
export class TransactionSyndicAddComponent implements OnInit {
  form: FormGroup;
  submit: boolean = false;
  edit: boolean = false;
  transaction: any;
  title: string = '';
  comptes: any[] = [];

  types = [
    { label: 'Encaissement', value: 'ENCAISSEMENT' },
    { label: 'Décaissement', value: 'DECAISSEMENT' }
  ];

  categories = [
    { label: 'Appel de fonds', value: 'APPEL_FONDS' },
    { label: 'Pénalité', value: 'PENALITE' },
    { label: 'Honoraire', value: 'HONORAIRE' },
    { label: 'Travaux', value: 'TRAVAUX' },
    { label: 'Remboursement', value: 'REMBOURSEMENT' },
    { label: 'Autre', value: 'AUTRE' }
  ];

  modesPaiement = [
    { label: 'Virement', value: 'VIREMENT' },
    { label: 'Chèque', value: 'CHEQUE' },
    { label: 'Espèces', value: 'ESPECES' },
    { label: 'Mobile Money', value: 'MOBILE_MONEY' },
    { label: 'Prélèvement', value: 'PRELEVEMENT' }
  ];

  constructor(
    public toastr: ToastrService,
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    private transactionService: TransactionSyndicService,
    private compteService: CompteService,
    private syndicService: SyndicService
  ) {
    this.edit = this.transactionService.edit;
    this.transaction = this.transactionService.getTransactionSyndic();
    const ref = this.transaction ? this.transaction.reference : '';
    this.title = (!this.edit) ? 'Ajouter une transaction' : 'Modifier la transaction ' + ref;
  }

  ngOnInit(): void {
    this.createForm();
    this.loadComptes();
    if (this.edit && this.transaction) { this.setFormValue(); }
  }

  loadComptes(): void {
    const trusteeUuid = this.syndicService.getSyndic()?.uuid;
    if (trusteeUuid) {
      this.compteService.getList(trusteeUuid).subscribe((res: any) => {
        this.comptes = res || [];
      });
    }
  }

  createForm(): void {
    this.form = this.formBuild.group({
      uuid: [null],
      montant: [0, [Validators.required, Validators.min(1)]],
      date: [null, [Validators.required]],
      type: ['ENCAISSEMENT', [Validators.required]],
      categorie: [null],
      modePaiement: ['VIREMENT'],
      reference: [null],
      libelle: [null],
      description: [null],
      compte: [null, [Validators.required]],
      ownerCo: [null],
      trustee: [this.syndicService.getSyndic()?.uuid, [Validators.required]]
    });
  }

  setFormValue(): void {
    this.form.patchValue({
      uuid: this.transaction.uuid,
      montant: this.transaction.montant,
      date: this.transaction.date,
      type: this.transaction.type,
      categorie: this.transaction.categorie,
      modePaiement: this.transaction.modePaiement,
      reference: this.transaction.reference,
      libelle: this.transaction.libelle,
      description: this.transaction.description,
      compte: this.transaction.compte?.uuid,
      ownerCo: this.transaction.ownerCo?.uuid,
      trustee: this.transaction.trustee?.uuid
    });
  }

  onSubmit(): void {
    this.submit = true;
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.transactionService.add(data).subscribe(
        (res: any) => {
          if (res?.status === 'success') {
            this.modal.close('ferme');
            if (this.edit) {
              this.emitter.event.emit({ action: 'TRANSACTION_SYNDIC_UPDATED', payload: res?.data });
            } else {
              this.emitter.event.emit({ action: 'TRANSACTION_SYNDIC_ADD', payload: res?.data });
            }
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        },
        (error: any) => {
          const msg = error?.error?.message || 'Une erreur est survenue';
          Swal.fire({ icon: 'error', title: 'Erreur', text: msg });
        }
      );
    }
  }

  onClose(): void { this.modal.close('ferme'); }
  get f() { return this.form.controls; }
}
